<template>
  <span>
    <v-menu offset-y left v-model="isMenuOpen" max-width="450px" min-width="400px" max-height="600px">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" @click="getReservations()">
          <v-badge :color="reservations.length > 0 ? 'warning' : ''" overlap :content="totalCount">
            <v-icon>mdi-bullseye-arrow</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-skeleton-loader
        v-if="request.loading"
        ref="skeleton"
        type="list-item-avatar-three-line@1"
        class="mx-auto"
      ></v-skeleton-loader>
      <v-list v-if="!request.loading && isMenuOpen" dense subheader>
        <v-subheader>{{ $lang('main.navbar.reservations_pending.title') }}</v-subheader>
        <v-divider></v-divider>
        <v-list-item v-if="!reservations.length">
          {{$lang('main.crud.no_records')}}
        </v-list-item>
        <v-list-item
          v-for="(reservation, r) in reservations"
          :key="r"
          @click="openEditing(reservation.id)"
          three-line
        >
          <v-list-item-avatar>
            <img :src="reservation.source.image_url" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ reservation.client.name }}</v-list-item-title>
            <v-list-item-subtitle>
              <v-icon small>mdi-office-building</v-icon>
              {{ reservation.property.name }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ $toDateFormat(reservation.start_date) }}
              <v-icon small>mdi-arrow-right</v-icon>
              {{ $toDateFormat(reservation.end_date) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-btn
            :to="{
            name: 'reservations',
            query: {
              unassigned: true,
              not_status: $const('ConstReservationStatuses', 'CANCELED')
              }
            }"
            class="primary"
            small
          >{{ $lang('main.navbar.reservations_pending.view_all') }}</v-btn>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog
      v-model="isOpenEditing"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <editing-form
        v-if="isOpenEditing"
        :item-id="activeId"
        @cancel="closeEditing"
        @error="failed"
        @success="updated"
      ></editing-form>
    </v-dialog>
  </span>
</template>

<script>
  import {mapState} from "vuex";

  import {
    GET_RESERVATIONS_UNASSIGNED,
    LISTEN_RESERVATIONS_UNASSIGNED,
  } from "@/store/reservations/actions";

  import EditingForm from "@/pages/reservations/EditingForm";

  export default {
    name: "UnassignedReservations",
    components: {
      EditingForm
    },
    data() {
      return {
        search: null,
        activeId: null,
        isOpenEditing: false,
        isMenuOpen: false,
      };
    },
    mounted() {
      if (this.$can('INTERNAL_SUPPORT')) {
        return;
      }
      this.getReservations();
      // this.listenReservations();
    },
    methods: {
      openEditing(id) {
        this.isOpenEditing = true;
        this.activeId = id;
      },
      closeEditing() {
        this.isOpenEditing = false;
        this.activeId = null;
      },
      updated() {
        this.closeEditing();
        this.showNotification(this.$lang("main.crud.success_update"), "success");
      },
      failed() {
        this.showNotification(this.$lang("main.crud.something_went_wrong"), "error");
      },
      getReservations() {
        this.$store.dispatch(GET_RESERVATIONS_UNASSIGNED, {
          limit: 5,
          unassigned: true,
          withUnassigned: true,
        });
      },
      // listenReservations() {
      //   this.$store.dispatch(LISTEN_RESERVATIONS_UNASSIGNED);
      // }
    },
    computed: {
      ...mapState({
        request: state => state.reservations.getUnassignedRequest
      }),
      reservations() {
        return this.request.collection;
      },
      totalCount() {
        if (!this.request.pagination || !this.request.pagination.total) {
          return 0;
        }

        return this.request.pagination.total;
      },
    }
  };
</script>

<style scoped></style>
